import { Office } from "./office.model";

export class OfficeDeskRelation{
    public systemId: number;
    public locationId: number;
    public deskId: number;
    public office: Office
    public officeId: number;
}